const BASE_URL = process.env.REACT_APP_API_URL ?? "http://localhost:5000";

export const getHotelFullDetails = async (hotelId) => {
  const response = await fetch(
    `${BASE_URL}/api/feasibility/GetHotelFullDetails/${hotelId}`
  );
  if (!response.ok) {
    throw new Error("Failed to fetch hotel details");
  }
  return response.json();
};

export const submitHotelCertification = async (apiData) => {
  const response = await fetch(
    `${BASE_URL}/api/feasibility/SubmitHotelCertification`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(apiData),
    }
  );
  if (!response.ok) {
    throw new Error("Failed to submit hotel certification");
  }
  return response.json();
};

export const getAllHotelCertificationDetails = async () => {
  const response = await fetch(
    `${BASE_URL}/api/feasibility/GetAllHotelCertificationDetails`
  );
  if (!response.ok) {
    throw new Error("Failed to fetch data");
  }
  return response.json();
};

export const deleteHotels = async (hotelIds) => {
  const response = await fetch(`${BASE_URL}/api/feasibility/DeleteHotels`, {
    method: "DELETE",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(hotelIds),
  });
  if (!response.ok) {
    throw new Error("Failed to delete hotel(s)");
  }
  return response.json();
};
